import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-619b9e8d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navIcon = _resolveComponent("navIcon");
  const _component_myMenu = _resolveComponent("myMenu");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, item => {
    return _openBlock(), _createElementBlock(_Fragment, null, [item?.children && item?.children?.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: item.id,
      index: item.path
    }, {
      title: _withCtx(() => [_createVNode(_component_navIcon, {
        icon: item.icon
      }, null, 8, ["icon"]), !$props.collapse ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.cname), 1)) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_createVNode(_component_myMenu, {
        data: item.children
      }, null, 8, ["data"])]),
      _: 2
    }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
      key: 1,
      index: item.path,
      onClick: $event => $options.toRouer(item)
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString(item.cname), 1)]),
      default: _withCtx(() => [_createVNode(_component_navIcon, {
        icon: item.icon
      }, null, 8, ["icon"])]),
      _: 2
    }, 1032, ["index", "onClick"]))], 64);
  }), 256))]);
}